<mat-card appearance="outlined">
    <mat-card-header>
        <mat-card-title>{{ 'Dashboard.ShareholdersDomicile' | translate }}</mat-card-title>
    </mat-card-header>
    <mat-card-content>
        @if (data.length > 0) {
            <div>
                <table>
                    <tr>
                        <th></th>
                        <th>{{ 'ShareholdersDomicileWidget.RegisteredShares' | translate }}</th>
                        <th></th>
                    </tr>
                    @for (item of data; track item; let isLast = $last) {
                        <tr>
                            <td class="text-left">{{ item.label }}</td>
                            <td>{{ item.value | slNumber }}</td>
                            <td>{{ item.percentage | slNumber: 2 }}%</td>
                        </tr>
                    }
                    <tr class="separator">
                        <td class="text-left">
                            <strong>{{ 'General.Total' | translate }}</strong>
                        </td>
                        <td>
                            <strong>{{ total | slNumber }}</strong>
                        </td>
                        <td><strong>100.00%</strong></td>
                    </tr>
                </table>
            </div>
        }
    </mat-card-content>
</mat-card>
